/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

import { PickPlayerRequest } from '../models/pick-player.request';
import { ReleasePlayerRequest } from '../models/release-player.request';
import { ReadyPlayerRequest } from '../models/ready-player.request';
import { Player } from '../models/player.entity';
import { ReadyPlayerV3Request } from '../models/ready-player-v3.request';

export type PlayersUpdatePathVariables = { gameId: string; id: string };
export type PlayersUpdateV3PathVariables = { gameId: string; id: string };

@Injectable()
export class PlayersService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	/**
	 * @deprecated use updateV3 instead
	 */
	public update(
		path: PlayersUpdatePathVariables,
		body: PickPlayerRequest | ReleasePlayerRequest | ReadyPlayerRequest,
	): Observable<Player> {
		return this.http.patch<Player>(
			`${this.config.apiUrl}/api/v2/private/games/${path.gameId}/players/${path.id}`,
			body,
		);
	}

	public updateV3(
		path: PlayersUpdateV3PathVariables,
		body: ReadyPlayerV3Request,
	): Observable<Player> {
		return this.http.patch<Player>(
			`${this.config.apiUrl}/api/v3/private/games/${path.gameId}/players/${path.id}`,
			body,
		);
	}
}
